import { z } from 'zod';

import { ProseMirrorJSONSchema } from './ProseMirrorJSONSchema';
import { BaseQuestionWidgetSchema } from './QuestionBaseSchema';
import { Feedbacks } from '../../../utils/evaluation/feedback';
import { EvaluationMode, WidgetType } from '../../utils/widgetsUtils';

export enum TextEditorTypes {
  Simple = 'simple',
  Rich = 'rich'
}

export const OpenQuestionWidgetStaticSchema = BaseQuestionWidgetSchema(WidgetType.OpenQuestion).extend({
  evaluationMode: z.nativeEnum(EvaluationMode),
  /**
   * ProseMirror JSON
   */
  placeholderFragment: ProseMirrorJSONSchema,
  showAnswerButton: z.boolean(),
  /**
   * ProseMirror JSON
   */
  studentIndicatorFragment: ProseMirrorJSONSchema,
  feedback: z.nativeEnum(Feedbacks),
  saveAnswers: z.boolean(),
  textEditorType: z.nativeEnum(TextEditorTypes),
  showElements: z.object({
    text: z.boolean(),
    recording: z.boolean(),
    image: z.boolean(),
    file: z.boolean(),
    embed: z.boolean()
  })
});

export type OpenQuestionWidgetStaticSchema = z.infer<typeof OpenQuestionWidgetStaticSchema>;
